"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BTCNodeClient = void 0;
const tslib_1 = require("tslib");
const bitcoin = (0, tslib_1.__importStar)(require("bitcoinjs-lib"));
const axios_1 = (0, tslib_1.__importDefault)(require("axios"));
const bsert_1 = (0, tslib_1.__importDefault)(require("@summa-tx/bitcoin-spv-js-clients/lib/vendor/bsert"));
const merkle_1 = (0, tslib_1.__importDefault)(require("@summa-tx/bitcoin-spv-js-clients/lib/vendor/merkle"));
const hash256_1 = (0, tslib_1.__importDefault)(require("@summa-tx/bitcoin-spv-js-clients/lib/vendor/hash256"));
const reverseAndSwap = (dataP) => {
    let data = typeof dataP === 'number' ? dataP.toString(16) : dataP;
    let result = '';
    data = data.split('').reverse().join('');
    for (let i = 0; i < data.length - 1; i += 2) {
        result += data[i + 1] + data[i];
    }
    return result;
};
class BTCNodeClient {
    constructor(host) {
        this.loadMerkleProof = async (hash, height) => {
            const merkleProofRes = await this._loadMerkleProof(hash, height);
            return (merkleProofRes[0]
                .map((value) => Buffer.from(value, 'hex').toString('hex'))
                .join(''));
        };
        this._loadMerkleProof = async (txid, height) => {
            const block = await this._loadBlockByHeight(height);
            let index = -1;
            const txs = [];
            for (let i = 0; i < block.tx.length; i++) {
                const txHash = block.tx[i];
                if (txHash === txid) {
                    index = i >>> 0;
                }
                txs.push(Buffer.from(txHash, 'hex').reverse());
            }
            (0, bsert_1.default)(index >= 0, 'Transaction not in block.');
            const [root] = merkle_1.default.createRoot(hash256_1.default, txs.slice());
            bsert_1.default.bufferEqual(Buffer.from(block.merkleroot, 'hex').reverse(), root);
            const branch = merkle_1.default.createBranch(hash256_1.default, index, txs.slice());
            const proof = [];
            for (const hash of branch) {
                proof.push(hash.toString('hex'));
            }
            return [proof, index];
        };
        this.loadBlockByHeight = async (height) => {
            const response = await axios_1.default.get(`${this.host}/header/${height}`);
            const block = new bitcoin.Block();
            block.version = response.data.version;
            block.timestamp = response.data.time;
            block.bits = response.data.bits;
            block.prevHash = Buffer.from(reverseAndSwap(response.data.prevBlock), 'hex');
            block.merkleRoot = Buffer.from(reverseAndSwap(response.data.merkleRoot), 'hex');
            block.nonce = response.data.nonce;
            block.height = response.data.height;
            block.hash = response.data.hash;
            block.chainwork = response.data.chainwork;
            return block;
        };
        this.loadBtcTx = async (txHash) => {
            const txResponse = await axios_1.default.get(`${this.host}/tx/${txHash}`);
            return txResponse.data;
        };
        this._loadBlockByHeight = async (height) => {
            const r = await axios_1.default.post(`${this.host}`, JSON.stringify({
                method: 'getblockbyheight',
                params: [height, true, false],
            }), {
                transformRequest: [
                    (data, headers) => {
                        delete headers.post['Content-Type'];
                        return data;
                    },
                ],
            });
            return r.data.result;
        };
        this.loadTxsByAddress = async (bech32Address) => {
            try {
                const response = await axios_1.default.get(`${this.host}/tx/address/${bech32Address}`);
                return response.data;
            }
            catch (e) {
                console.error('Error getTransactionByAddress', {
                    error: e,
                    bech32Address,
                    url: this.host,
                });
            }
        };
        this.loadWalletTxList = async (bech32Address) => {
            const response = await axios_1.default.get(`${this.host}/tx/address/${bech32Address}`);
            return response.data;
        };
        this.loadBasicInfo = async () => {
            const response = await axios_1.default.get(`${this.host}`);
            return response.data;
        };
        this.loadFee = async () => {
            const response = await axios_1.default.get(`${this.host}/fee`);
            return response.data.rate;
        };
        this.host = host;
    }
}
exports.BTCNodeClient = BTCNodeClient;
